define('util/codeUtils',[
    'lib/lodash4',
    'lib/knockout',
    'services/loggingService'
], function (
    _,
    ko,
    LOG
) {
    "use strict";

    // ==========================================================
    // Constants
    // ==========================================================

    var LOG_LEVEL_WARN ="warn";

    /**
     * This utility allows for an easier transition from deprecated apis to their new delegated functions.
     * @param message - String -  The message to log when the deprecated function is called
     * @param options - object  - optional properties to affect the behavior of the delegated function
     *                  The properties of the options object are as follow:
     *                      context: the context in which to run the delegated function
     *                      logLevel: the log level to log the message with.
     * @param delegatedFunc - function - The function that the deprecated function is delegated to
     * @returns function
     *
     *
     *
     * Please note the options parameter is optional. Hence the deprecate api can be invoked in the following manner:
     *
     * deprecate(myString, myOptions, myDelegatedFunction)
     *
     * OR
     *
     * deprecate(myString, myDelegatedFunction)
     *
     * Given that the delegated function is the last argument this allows one to do the following:
     *
     * var myDeprecateUtilFunc = _.partial(delegate, message, option);
     *
     *     OR
     *
     * var myDeprecateUtilFunc = _.partial(delegate, message);
     *
     *
     * // Then later invoke as in:
     *
     * myDeprecateUtilFunc(delegatedFunction);
     *
     */

    var deprecate = function(){
        var delegatedFunc;
        var options = {};

        var message = arguments[0];

        if (typeof arguments[1] === 'function'){
            delegatedFunc = arguments[1];
        } else {
            options = arguments[1];
            delegatedFunc = arguments[2];
        }

        if (typeof message !== 'string' || typeof delegatedFunc !== 'function'){
            throw('Sample usage of deprecate api:  deprecate(myMessage, myOptions, myDelegatedFunction)  OR  deprecate(myMessage, myDelegatedFunction)' );
        }

        message = "[DEPRECATION WARNING]: " + message;  //helps to have some consistency across all messages for search.
        options = _.assign({
            context: this,
            logLevel: LOG_LEVEL_WARN
        }, options);

        var  funcToCall = function (message, options, delegatedFunc) {
            var args = Array.prototype.slice.call(arguments);
            var params = args.slice(3, args.length);

            LOG[options.logLevel](message);

            return delegatedFunc.apply(this, params);
        };
        return funcToCall.bind(options.context, message, options, delegatedFunc);
    };

    /**
     * Utility that will accepts parameters to generate a valid class attribute.
     *
     * @param prefix {string} -- A string prefix to be prepended to the resulting
     *      class attribute.
     * @param str {string} -- String value to be formatted into class attribute.
     *
     **/
    var generateClassFromString = function (prefix, str) {
        var whitespace = /\s+/g;
        var nonAlpha = /[^A-Za-z-]+/g;
        str = str ? ko.unwrap(str) : "";

        var classValue = str.replace(whitespace,"-");
        classValue = classValue.replace(nonAlpha,"");

        prefix = prefix || "";

        return prefix + classValue.toLowerCase();
    };

    return {
        deprecate: deprecate,
        generateClassFromString: generateClassFromString
    };

});

